import { EntityFile } from "../../entity/EntityFile";

export class DtoFilesPostRes extends EntityFile {}
